import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { DEMO_MODE, THEME_COLOR3 } from "../constants";

const Footer = () => {
  return (
    <Grid container direction="row" justifyContent="space-between">
      <Typography
        sx={{
          color: THEME_COLOR3,
          fontSize: 10,
          fontFamily: "IBMPlexSansRegular",
        }}
      >
        Copyright © 2023 {DEMO_MODE ? 'Clinic Admin Demo' : 'Celesta'}. All rights reserved.
      </Typography>
    </Grid>
  );
};

export default Footer;
